import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'





const ContractArchive = resolve => {
    require.ensure(['@/components/Contracts/Archive/ContractArchive.vue'], () => {
        resolve(require('@/components/Contracts/Archive/ContractArchive.vue'));
    });
};


const ReportArchive = resolve => {
    require.ensure(['@/components/Report/Archive/ReportArchive.vue'], () => {
        resolve(require('@/components/Report/Archive/ReportArchive.vue'));
    });
};


const PublishArchive = resolve => {
    require.ensure(['@/components/Publish/Archive/PublishArchive.vue'], () => {
        resolve(require('@/components/Publish/Archive/PublishArchive.vue'));
    });
};

const BaresiSabt = resolve => {
    require.ensure(['@/components/Contracts/Baressi/BaresiSabt.vue'], () => {
        resolve(require('@/components/Contracts/Baressi/BaresiSabt.vue'));
    });
};

const Anjam = resolve => {
    require.ensure(['@/components/Contracts/Anjam/Anjam.vue'], () => {
        resolve(require('@/components/Contracts/Anjam/Anjam.vue'));
    });
};

const BaresiAnjam = resolve => {
    require.ensure(['@/components/Contracts/BaressiAnjam/BaresiAnjam.vue'], () => {
        resolve(require('@/components/Contracts/BaressiAnjam/BaresiAnjam.vue'));
    });
};


const Pardakht = resolve => {
    require.ensure(['@/components/Contracts/Pardakht/Pardakht.vue'], () => {
        resolve(require('@/components/Contracts/Pardakht/Pardakht.vue'));
    });
};

const AddContractOmomi = resolve => {
    require.ensure(['@/components/Contracts/Add/AddContractOmomi.vue'], () => {
        resolve(require('@/components/Contracts/Add/AddContractOmomi.vue'));
    });
};

const Eslah = resolve => {
    require.ensure(['@/components/Contracts/Eslah/Eslah.vue'], () => {
        resolve(require('@/components/Contracts/Eslah/Eslah.vue'));
    });
};

const AddPublishBook = resolve => {
    require.ensure(['@/components/Publish/Add/AddPublishBook.vue'], () => {
        resolve(require('@/components/Publish/Add/AddPublishReport.vue'));
    });
};

const AddPublishReport = resolve => {
    require.ensure(['@/components/Publish/Add/AddPublishReport.vue'], () => {
        resolve(require('@/components/Publish/Add/AddPublishReport.vue'));
    });
};

const PublishBaresiSabt = resolve => {
    require.ensure(['@/components/Publish/Baressi/PublishBaresiSabt.vue'], () => {
        resolve(require('@/components/Publish/Baressi/PublishBaresiSabt.vue'));
    });
};


const PublishAnjam = resolve => {
    require.ensure(['@/components/Publish/Anjam/PublishAnjam.vue'], () => {
        resolve(require('@/components/Publish/Anjam/PublishAnjam.vue'));
    });
};


const PublishBaresiAnjam = resolve => {
    require.ensure(['@/components/Publish/BaressiAnjam/PublishBaresiAnjam.vue'], () => {
        resolve(require('@/components/Publish/BaressiAnjam/PublishBaresiAnjam.vue'));
    });
};

const PublishPardakht = resolve => {
    require.ensure(['@/components/Publish/Pardakht/PublishPardakht.vue'], () => {
        resolve(require('@/components/Publish/Pardakht/PublishPardakht.vue'));
    });
};


const Distribute = resolve => {
    require.ensure(['@/components/Distribute/Distribute.vue'], () => {
        resolve(require('@/components/Distribute/Distribute.vue'));
    });
};


const AddDistributeLetter = resolve => {
    require.ensure(['@/components/Distribute/AddLetter/AddDistributeLetter.vue'], () => {
        resolve(require('@/components/Distribute/AddLetter/AddDistributeLetter.vue'));
    });
};


const DistributeBaresiSabt = resolve => {
    require.ensure(['@/components/Distribute/Baressi/DistributeBaresiSabt.vue'], () => {
        resolve(require('@/components/Distribute/Baressi/DistributeBaresiSabt.vue'));
    });
};


const DistributeBaresiAnjam = resolve => {
    require.ensure(['@/components/Distribute/BaressiAnjam/DistributeBaresiAnjam.vue'], () => {
        resolve(require('@/components/Distribute/BaressiAnjam/DistributeBaresiAnjam.vue'));
    });
};


const AddDistribute = resolve => {
    require.ensure(['@/components/Distribute/AddDist/AddDistribute.vue'], () => {
        resolve(require('@/components/Distribute/AddDist/AddDistribute.vue'));
    });
};


const NotifyDistribute = resolve => {
    require.ensure(['@/components/Distribute/NotifyDist/NotifyDistribute.vue'], () => {
        resolve(require('@/components/Distribute/NotifyDist/NotifyDistribute.vue'));
    });
};


const Meeting = resolve => {
    require.ensure(['@/components/Meeting/Meeting.vue'], () => {
        resolve(require('@/components/Meeting/Meeting.vue'));
    });
};


const AddMeeting = resolve => {
    require.ensure(['@/components/Meeting/Add/AddMeeting.vue'], () => {
        resolve(require('@/components/Meeting/Add/AddMeeting.vue'));
    });
};


const MeetingBaresiSabt = resolve => {
    require.ensure(['@/components/Meeting/Baressi/MeetingBaresiSabt.vue'], () => {
        resolve(require('@/components/Meeting/Baressi/MeetingBaresiSabt.vue'));
    });
};


const MeetingAnjam = resolve => {
    require.ensure(['@/components/Meeting/Anjam/MeetingAnjam.vue'], () => {
        resolve(require('@/components/Meeting/Anjam/MeetingAnjam.vue'));
    });
};


const MeetingBaresiAnjam = resolve => {
    require.ensure(['@/components/Meeting/BaressiAnjam/MeetingBaresiAnjam.vue'], () => {
        resolve(require('@/components/Meeting/BaressiAnjam/MeetingBaresiAnjam.vue'));
    });
};


const Report = resolve => {
    require.ensure(['@/components/Report/Report.vue'], () => {
        resolve(require('@/components/Report/Report.vue'));
    });
};


const AddReport = resolve => {
    require.ensure(['@/components/Report/Add/AddReport.vue'], () => {
        resolve(require('@/components/Report/Add/AddReport.vue'));
    });
};


const ReportBaresiSabt = resolve => {
    require.ensure(['@/components/Report/Baressi/ReportBaresiSabt.vue'], () => {
        resolve(require('@/components/Report/Baressi/ReportBaresiSabt.vue'));
    });
};


const ReportAnjam = resolve => {
    require.ensure(['@/components/Report/Anjam/ReportAnjam.vue'], () => {
        resolve(require('@/components/Report/Anjam/ReportAnjam.vue'));
    });
};


const ReportBaresiAnjam = resolve => {
    require.ensure(['@/components/Report/BaressiAnjam/ReportBaresiAnjam.vue'], () => {
        resolve(require('@/components/Report/BaressiAnjam/ReportBaresiAnjam.vue'));
    });
};


const Letter = resolve => {
    require.ensure(['@/components/Letter/Letter.vue'], () => {
        resolve(require('@/components/Letter/Letter.vue'));
    });
};


const ExportLetter = resolve => {
    require.ensure(['@/components/Letter/Add/ExportLetter.vue'], () => {
        resolve(require('@/components/Letter/Add/ExportLetter.vue'));
    });
};

const ImportLetter = resolve => {
    require.ensure(['@/components/Letter/Add/ImportLetter.vue'], () => {
        resolve(require('@/components/Letter/Add/ImportLetter.vue'));
    });
};

const LetterBaresiSabt = resolve => {
    require.ensure(['@/components/Letter/Baressi/LetterBaresiSabt.vue'], () => {
        resolve(require('@/components/Letter/Baressi/LetterBaresiSabt.vue'));
    });
};

const Message = resolve => {
    require.ensure(['@/components/message/Message.vue'], () => {
        resolve(require('@/components/message/Message.vue'));
    });
};


const AddMessage = resolve => {
    require.ensure(['@/components/message/Add/AddMessage.vue'], () => {
        resolve(require('@/components/message/Add/AddMessage.vue'));
    });
};

const MessageBaresiSabt = resolve => {
    require.ensure(['@/components/message/Baressi/MessageBaresiSabt.vue'], () => {
        resolve(require('@/components/message/Baressi/MessageBaresiSabt.vue'));
    });
};


const AddUser = resolve => {
    require.ensure(['@/components/User/Add/AddUser.vue'], () => {
        resolve(require('@/components/User/Add/AddUser.vue'));
    });
};


const User = resolve => {
    require.ensure(['@/components/User/User.vue'], () => {
        resolve(require('@/components/User/User.vue'));
    });
};


const ListUser = resolve => {
    require.ensure(['@/components/User/List/ListUser.vue'], () => {
        resolve(require('@/components/User/List/ListUser.vue'));
    });
};

const Add = resolve => {
    require.ensure(['@/components/Add.vue'], () => {
        resolve(require('@/components/Add.vue'));
    });
};
const Index = resolve => {
    require.ensure(['@/components/Index/Index.vue'], () => {
        resolve(require('@/components/Index/Index.vue'));
    });
};

const Contracts = resolve => {
    require.ensure(['@/components/Contracts/Contracts.vue'], () => {
        resolve(require('@/components/Contracts/Contracts.vue'));
    });
};
const AddContractMojriHaghighi = resolve => {
    require.ensure(['@/components/Contracts/Add/AddContractMojriHaghighi.vue'], () => {
        resolve(require('@/components/Contracts/Add/AddContractMojriHaghighi.vue'));
    });
};
const AddContractMojriHoghoghiOmomi = resolve => {
    require.ensure(['@/components/Contracts/Add/AddContractMojriHoghoghiOmomi.vue'], () => {
        resolve(require('@/components/Contracts/Add/AddContractMojriHoghoghiOmomi.vue'));
    });
};const AddContractMojriHoghoghiKhososi = resolve => {
    require.ensure(['@/components/Contracts/Add/AddContractMojriHoghoghiKhososi.vue'], () => {
        resolve(require('@/components/Contracts/Add/AddContractMojriHoghoghiKhososi.vue'));
    });
};const AddContractNazer = resolve => {
    require.ensure(['@/components/Contracts/Add/AddContractNazer.vue'], () => {
        resolve(require('@/components/Contracts/Add/AddContractNazer.vue'));
    });
};const AddContractMotarjem = resolve => {
    require.ensure(['@/components/Contracts/Add/AddContractMotarjem.vue'], () => {
        resolve(require('@/components/Contracts/Add/AddContractMotarjem.vue'));
    });
};const Publish = resolve => {
    require.ensure(['@/components/Publish/Publish.vue'], () => {
        resolve(require('@/components/Publish/Publish.vue'));
    });
};

Vue.use(Router);


export default new Router({


    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        if (to.hash) {
            return {selector: to.hash};
        }
        return {x: 0, y: 0};
    },
    routes: [
        {
            path: '/add',
            name: 'Add',
            title:'صفحه ورود',
            component: Add,
        }, {
            path: '/',
            name: 'Index',
            title:'صفحه اصلی',

            component: Index,
        }, {
            path: '/contracts',
            name: 'Contracts',
            title:'قراردادها',

            component: Contracts,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        }, {
            path: '/contracts/addmojrihaghighi/:id?',
            name: 'AddContractMojriHaghighi',
            title:'افزودن قرارداد مجری حقیقی',
            component: AddContractMojriHaghighi,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        }, {
            path: '/contracts/addmojrihoghoghiomomi/:id?',
            name: 'AddContractMojriHoghoghiOmomi',
            title:'افزودن قرارداد مجری حقوقی عمومی',

            component: AddContractMojriHoghoghiOmomi,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },{
            path: '/contracts/addmojrihoghoghikhososi/:id?',
            name: 'AddContractMojriHoghoghiKhososi',
            title:'افزودن قرارداد مجری حقوقی خصوصی',

            component: AddContractMojriHoghoghiKhososi,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },{
            path: '/contracts/addnazer/:id?',
            name: 'AddContractNazer',
            title:'افزودن قرارداد ناظر',

            component: AddContractNazer,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },{
            path: '/contracts/addmotarjem/:id?',
            name: 'AddContractMotarjem',
            title:'افزودن قرارداد مترجم',
            component: AddContractMotarjem,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },{
            path: '/contracts/baresisabt/:id',
            name: 'BaresiSabt',
            title:' بررسی ثبت قرارداد',
            component: BaresiSabt,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },{
            path: '/contracts/anjam/:id',
            name: 'Anjam',
            title:' انجام قرارداد',

            component: Anjam,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },{
            path: '/contracts/baresianjam/:id',
            name: 'BaresiAnjam',
            title:' بررسی انجام قرارداد',
            component: BaresiAnjam,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },{
            path: '/contracts/pardakht/:id',
            name: 'Pardakht',
            title:' پرداخت قرارداد',

            component: Pardakht,
            beforeEnter(to, from, next) {
                if ((store.state.userRole == 'KarshenasMali') || (store.state.userLevel==1) || (store.state.userLevel==2)) {

                    next();
                } else {
                    store.state.notify.is = true;
                    store.state.notify.type = store.state.NotifyOption.types.alert;
                    store.state.notify.text = 'تنها کارشناس مالی قادر به پرداخت است';
                    next(false);
                }
            }
        },{
            path: '/contracts/addcontractomomi/:id?',
            name: 'AddContractOmomi',
            title:' ثبت قرارداد عمومی',
            component: AddContractOmomi,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },{
            path: '/contracts/eslah/:id?',
            name: 'Eslah',
            title:' اصلاحیه قرارداد',
            component: Eslah,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },
        {
            path: '/contracts/archive/:id',
            name: 'ContractArchive',
            title:'بایگانی قرارداد',
            component: ContractArchive,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 5)) {
                    next();
                } else next('/');
            }
        },

        {
            path: '/publish/archive/:id',
            name: 'PublishArchive',
            title:'بایگانی نشر',
            component: PublishArchive,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 4)) {
                    next();
                } else next('/');
            }
        },

        {
            path: '/publish',
            name: 'Publish',
            title:'انتشارات',

            component: Publish,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 4)) {
                    next();
                } else next('/');
            }
        },{
            path: '/publish/addbook/:id',
            name: 'AddPublishBook',
            title:'ثبت نشر کتاب',
            component: AddPublishBook,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 4)) {
                    next();
                } else next('/');
            }
        },{
            path: '/publish/addreport/:id',
            name: 'AddPublishReport',
            title:'ثبت نشر گزارش کارشناسی',
            component: AddPublishReport,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 4)) {
                    next();
                } else next('/');
            }
        },{
            path: '/publish/baresisabt/:id',
            name: 'PublishBaresiSabt',
            title:'بررسی ثبت نشر',
            component: PublishBaresiSabt,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 4)) {
                    next();
                } else next('/');
            }
        },{
            path: '/publish/anjam/:id',
            name: 'PublishAnjam',
            title:'انجام نشر',

            component: PublishAnjam,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 4)) {
                    next();
                } else next('/');
            }
        },{
            path: '/publish/baresianjam/:id',
            name: 'PublishBaresiAnjam',
            title:'بررسی انجام نشر',

            component: PublishBaresiAnjam,
            beforeEnter(to, from, next) {
                if (!(store.state.userLevel == 4)) {
                    next();
                } else next('/');
            }
        },{
            path: '/publish/pardakht/:id',
            name: 'PublishPardakht',
            title:'پرداخت نشر',

            component: PublishPardakht,
            beforeEnter(to, from, next) {
                if ((store.state.userRole == 'KarshenasMali') || (store.state.userLevel==1) || (store.state.userLevel==2)) {

                    next();
                } else {

                    store.state.notify.is = true;
                    store.state.notify.type = store.state.NotifyOption.types.alert;
                    store.state.notify.text = 'تنها کارشناس مالی قادر به پرداخت است';
                    next('/');
                    }
            }
        },{
            path: '/distribute',
            name: 'Distribute',
            title:'توزیع',
            component: Distribute,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/distribute/addletter/:id',
            name: 'AddDistributeLetter',
            title:'ثبت نامه توزیع',

            component: AddDistributeLetter,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/distribute/anjam/:id',
            name: 'DistributeAnjam',
            title:'ثبت توزیع',

            component: AddDistribute,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },
        {
            path: '/distribute/baresianjam/:id',
            name: 'DistributeBaresiAnjam',
            title:'بررسی انجام توزیع',

            component: DistributeBaresiAnjam,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },
        {
            path: '/distribute/baresisabt/:id',
            name: 'DistributeBaresiSabt',
            title:'بررسی ثبت توزیع',

            component: DistributeBaresiSabt,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/distribute/notify/:id',
            name: 'NotifyDistribute',
            title:'اطلاع رسانی توزیع',

            component: NotifyDistribute,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/meeting',
            name: 'Meeting',
            title:'نشست ها',
            component: Meeting,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/meeting/add/:id?',
            name: 'AddMeeting',
            title:'ثبت نشست',
            component: AddMeeting,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/meeting/baresisabt/:id',
            name: 'MeetingBaresiSabt',
            title:'بررسی ثبت نشست',
            component: MeetingBaresiSabt,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/meeting/anjam/:id',
            name: 'MeetingAnjam',
            title:' انجام نسشت',

            component: MeetingAnjam,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/meeting/baresianjam/:id',
            name: 'MeetingBaresiAnjam',
            title:'بررسی انجام نشست',

            component: MeetingBaresiAnjam,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/report',
            name: 'Report',
            title:'گزارش های کارشناسی',
            component: Report,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },
        {
            path: '/report/archive/:id',
            name: 'ReportArchive',
            title:'بایگانی گزارش کارشناسی',
            component: ReportArchive,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },
        {
            path: '/report/add/:id?',
            name: 'AddReport',
            title:'ثبت پیشنهاد گزارش جدید',
            component: AddReport,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/report/baresisabt/:id',
            name: 'ReportBaresiSabt',
            title:'بررسی ثبت گزارش',
            component: ReportBaresiSabt,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/report/anjam/:id',
            name: 'ReportAnjam',
            title:'انجام گزارش',

            component: ReportAnjam,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/report/baresianjam/:id',
            name: 'ReportBaresiAnjam',
            title:'بررسی انجام گزارش',
            component: ReportBaresiAnjam,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1 || store.state.userLevel == 2 || store.state.userLevel == 3) {
                    next();
                } else next('/');
            }
        },{
            path: '/letter',
            name: 'Letter',
            title:'مکاتبات',
            component: Letter,
        },{
            path: '/letter/export/:id?',
            name: 'ExportLetter',
            title:'ثبت نامه صادره',

            component: ExportLetter,
        },{
            path: '/letter/import/:id?',
            name: 'ImportLetter',
            title:'ثبت نامه وارده',
            component: ImportLetter,
        },{
            path: '/letter/baresisabt/:id',
            name: 'LetterBaresiSabt',
            title:'بررسی ثبت نامه',
            component: LetterBaresiSabt,
        },{
            path: '/message',
            name: 'Message',
            title:'پیام ها',
            component: Message,
        },{
            path: '/message/add/:id?',
            name: 'AddMessage',
            title:'ثبت پیام جدید',
            component: AddMessage,
        },{
            path: '/message/baresisabt/:id',
            name: 'MessageBaresiSabt',
            title:'بررسی پیام',
            component: MessageBaresiSabt,
        },{
            path: '/user',
            name: 'User',
            title:'کاربران',
            component: User,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1) {
                    next();
                } else next('/');
            }
        },{
            path: '/user/add',
            name: 'AddUser',
            title:'افزودن کاربر',
            component: AddUser,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1) {
                    next();
                } else next('/');
            }
        },
        {
            path: '/user/edit/:id',
            name: 'EditUser',
            title:'ویرایش اطلاعات کاربر',
            component:AddUser ,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1) {
                    next();
                } else next('/');
            }
        },{
            path: '/user/list',
            name: 'ListUser',
            title:'ثبت لیست های انتخابی سیستم',
            component:ListUser ,
            beforeEnter(to, from, next) {
                if (store.state.userLevel == 1) {
                    next();
                } else next('/');
            }
        },

    ]
})
